import styles from './AlphaBanner.module.scss';

export function AlphaBanner() {
    return (
        <div className={styles.alphaBanner}>
            <span className={styles.alphaBanner__icon}>⚡</span>
            <span>Welcome to the Alpha release of KnowbleMind</span>
        </div>
    );
}
